import type { FormItemProps, SelectProps } from "antd";
import type { ReactNode } from "react";
import CustomSelect from "../../CustomSelect";
import { FormItem } from "../FormItem";
import { FormSkeleton } from "../FormSkeleton";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;
  showSkeleton?: boolean;

  /** `children` moved out of `selectProps` for convenience as it used frequently */
  children?: SelectProps["children"];
  /** `disabled` moved out of `selectProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `SelectProps`. */
  selectProps?: Omit<SelectProps, "disabled" | "children">;
};

export const FormSelect = <TForm = unknown>({
  label,
  disabled,
  showSkeleton = false,
  selectProps,
  children,
  ...rest
}: Props<TForm>) => (
  <div>
    {showSkeleton ? (
      <FormSkeleton label={label} />
    ) : (
      <FormItem<TForm> className="form-select-item" layout="vertical" label={label} {...rest}>
        <CustomSelect disabled={disabled} {...selectProps}>
          {children}
        </CustomSelect>
      </FormItem>
    )}
  </div>
);
